import { Link } from "react-router-dom";
import { Button } from "reactstrap";

export const EditStudentPageButtonGroup = ({ resetAndCancel, studentId }) => (
	<div className="mb-5 d-flex justify-content-between">
		<Link to={`/student/${studentId}`}>
			<button className="btn btn-sm btn-info text-nowrap" type="button">&lt; Back</button>
		</Link>

		<div>
			<Button size="sm" color="primary" type="submit">
				Save
			</Button>
			<Button size="sm" color="secondary" type="button" onClick={resetAndCancel}>
				Reset
			</Button>
		</div>
	</div>
);
